import request from '../utils/http'

const applyapis = {
    //查询流程列表
    getLoanList: query =>{
        return request({
            url: '/apply/getLoanList',
            method: 'get',
            params:query
        });
    },
    getAreaList:query =>{
        return request({
            url: '/apply/getAreaList',
            method: 'get',
            params:query
        });
    },
    getBankByAreaCode:query=>{
        return request({
            url: '/apply/getBankByAreaCode',
            method: 'get',
            params:query
        });
    },
    getCompanyPage:query=>{
        return request({
            url: '/apply/getCompanyPage',
            method: 'post',
            data:query
        });
    },
    addLoanApply:query=>{
        return request({
            url :'/apply/addLoanApply',
            method:'post',
            data:query
        })
    },
    addLoanApply2:query=>{
        return request({
            url :'/apply/addLoanApply2',
            method:'post',
            data:query
        })
    },

}

export default applyapis